const initialState = {
  skuIdApi: [],
  generateSkuApi: [],
  skuAdminDetail: [],
  productApproval: [],
  productView: {}
};

const SkuiIdGenerateReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_SKU_ID':
      return { ...state, skuIdApi: action.payload };
    case 'POST_SKU_API':
      return { ...state, generateSkuApi: action.payload };
    case 'POST_SKU_ADMIN_DETAILS':
      return { ...state, skuAdminDetail: action.payload };
    case 'PRODUCT_APPROVAL':
      return { ...state, productApproval: action.payload };
    case 'PRODUCT_VIEW':
      return { ...state, productView: action.payload };
    default:
      return state;
  }
};

export default SkuiIdGenerateReducer;
